import LegerTeacher from "../../../../../components/categories/siakad/laporan_adab/leger/HomeTeacher"
export default function Home() {
  
  return (
    <LegerTeacher />
  );
}